import { RavRecord, RecordSlots } from '#record/model';
import { DetailContext } from '#vessel/context';
import startOfDay from 'date-fns/startOfDay';
import { useContext } from 'react';
import { priorTrxauthzType } from './constants';
import { PriorTrxAuthz } from './model';
import isAfter from 'date-fns/isAfter';




export type PriorTrxListEntry = {

    key: string,
    authorisation: PriorTrxAuthz
    active: boolean,
    expired: boolean,
    revision: RavRecord & Pick<RecordSlots, typeof priorTrxauthzType>
}


export const usePriorTrxAuthzList = () => {

    const { vessel } = useContext(DetailContext)

    const now = startOfDay(Date.now())


    return (age: number) => {

        const authzmap = vessel.history.slice(age)
            .flatMap(revision => (revision[priorTrxauthzType]?.authzs ?? []).map( authorisation => {

                    const fromDate = startOfDay(new Date(authorisation.from))
                    const toDate = startOfDay(new Date(authorisation.to))
                    const expired = isAfter(now, toDate)
                    const active =  isAfter(now, fromDate) && !expired

                return {
                    key: `${startOfDay(new Date(authorisation.from))}-${startOfDay(new Date(authorisation.to))}`,
                    revision,
                    authorisation,
                    active,
                    expired

                } as PriorTrxListEntry

            }))

            // add new authz only if we haven't seen it before (as this is older)
            .reduce((acc, item) => acc.hasOwnProperty(item.key) ? acc : { ...acc, [item.key]: item }

                , {} as Record<string, PriorTrxListEntry>)

        return Object.values(authzmap).sort((a, b) => a.active ? b.active ? a.authorisation.from.localeCompare(a.authorisation.from) : -1 : 1)
    }

}